import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    window.history.replaceState(null, "", window.location.pathname);
    if (params.get("error") || !code || !state) {
      if (params.get("error") && params.get("error") !== "access_denied") toast.error("Google ile giriş tamamlanamadı.");
      nav("/giris", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google/callback", { code, state });
        await refresh();
        nav("/", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google ile giriş tamamlanamadı.");
        nav("/giris", { replace: true });
      }
    })();
  }, [location.search, nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm" data-testid="auth-callback">
      Giriş tamamlanıyor…
    </div>
  );
}
